// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '비보존제약',
  targetSheetName: '수수료율표',
  headerRowIndex: 3,
  headerRowCount: 1,
  dataStartRowIndex: 4,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    commissionRate: '요율',
    commissionNote: '비고',
  },
  requiredHeaders: [
    '품목군',
    '제품명',
    '보험코드',
    '성분명',
    '생산구분',
    '요율',
    '약가(원)',
    '비고',
    '약가비고',
  ],
});
